import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import {
  selectActiveTeam,
  selectActiveTeamPlayerOptions,
  selectActiveTeamPlayerOptionsOpposite,
} from 'features/match/matchSlice';

import { selectOwnGoalCheckbox, selectSelects, inputSliceActions } from 'features/input/inputSlice';

import AdvancedSelect from 'components/AdvancedSelect';
import IndirectAssistCheckbox from 'components/input/IndirectAssistCheckbox';
import OwnGoalCheckbox from 'components/input/OwnGoalCheckbox';
import selectOnChange from './helpers/selectOnChange';
import { keyboardActions } from '../../../features/keyboard/keyboardSlice';
import { ActiveFocusItemName } from '../../../features/keyboard/keyboardSliceTypes';

const EventInputGoal: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const team = useSelector(selectActiveTeam);
  const selects = useSelector(selectSelects);
  const playerOptions: any = useSelector(selectActiveTeamPlayerOptions);
  const playerOptionsOpposite = useSelector(selectActiveTeamPlayerOptionsOpposite);
  const isOwnGoal = useSelector(selectOwnGoalCheckbox);
  const activePlayerOptions = isOwnGoal ? playerOptionsOpposite : playerOptions;

  if (!team) return null;

  useEffect(() => {
    if (!selects.goalScorer.value) {
      dispatch(inputSliceActions.setActiveSelect(selects.goalScorer.id));
    } else if (!selects.assist.value) {
      dispatch(inputSliceActions.setActiveSelect(selects.assist.id));
    } else {
      dispatch(keyboardActions.setActiveFocusItem(ActiveFocusItemName.COMMENT));
    }
  }, []);

  const goalScorerMessage = intl.formatMessage({ id: 'eventInput.goalScorer' });
  const assistMessage = intl.formatMessage({ id: 'eventInput.assist' });

  const onChangeGoal = (option) => {
    selectOnChange(option, team, dispatch, intl);
    dispatch(inputSliceActions.setActiveSelect(selects.assist.id));
  };

  const onChangeAssist = (option) => {
    selectOnChange(option, team, dispatch, intl);
  };

  return (
    <div className="input-group goal">
      <div className="section">
        <OwnGoalCheckbox />
        <AdvancedSelect
          title={goalScorerMessage}
          options={activePlayerOptions?.filter((item) => item.value !== selects?.assist?.value)}
          select={selects.goalScorer}
          isClearable={true}
          onChange={onChangeGoal}
        />
      </div>
      <div className="section">
        <AdvancedSelect
          title={assistMessage}
          options={playerOptions?.filter((item) => item.value !== selects?.goalScorer?.value)}
          select={selects.assist}
          isClearable={true}
          onChange={onChangeAssist}
        />
        <IndirectAssistCheckbox disabled={isOwnGoal} />
      </div>
    </div>
  );
};

export default EventInputGoal;
